module.exports = __webpack_public_path__ + "static/media/badge.bacd5e55.svg";